import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Dict } from "@/types/interface";

export const dictSlice = createSlice({
    name: 'dict',
    initialState: {
        value: {
            robotType: [],
            sceneType: [],
            sceneStatus: [],
            robotSpecs: {},
            robotSpecsSimple: {}
        },
    },
    reducers: {
        updateDict: (state: any, action: PayloadAction<Dict>) => {
            state.value = action.payload || {};
        },
    },
});

export const { updateDict } = dictSlice.actions;

export default dictSlice.reducer;